import store from '../../framework/store';

export function findInstance(targetElement, behaviorName) {
	const rootElement = targetElement.closest(
		`[data-behavior${behaviorName ? `=${behaviorName}` : ''}]`
	);
	if (!rootElement) {
		return null;
	}

	return store.behaviourInstances.find(instance => instance.element === rootElement);
}
